/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateLookResemblanceAnswerMutationVariables = Types.Exact<{
  input: Types.VisionLookResemblanceSubmitInput;
}>;
export type UpdateLookResemblanceAnswerMutation = {
  __typename?: "Mutation";
  visionLookResemblanceSubmit?: {
    __typename?: "VisionLookResemblanceSubmitPayload";
    result: {
      __typename?: "VisionLookResemblanceSubmitError";
      message: string;
    } | {
      __typename?: "VisionLookResemblanceSubmitSuccess";
      look: {
        __typename?: "Look";
        id: string;
        resemblesMeAnswer?: boolean | null;
      };
    };
  } | null;
};
export const UpdateLookResemblanceAnswerDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "updateLookResemblanceAnswer"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "VisionLookResemblanceSubmitInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "visionLookResemblanceSubmit"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionLookResemblanceSubmitSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "look"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "resemblesMeAnswer"
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionLookResemblanceSubmitError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type UpdateLookResemblanceAnswerMutationFn = Apollo.MutationFunction<UpdateLookResemblanceAnswerMutation, UpdateLookResemblanceAnswerMutationVariables>;

/**
 * __useUpdateLookResemblanceAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateLookResemblanceAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLookResemblanceAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLookResemblanceAnswerMutation, { data, loading, error }] = useUpdateLookResemblanceAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLookResemblanceAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLookResemblanceAnswerMutation, UpdateLookResemblanceAnswerMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<UpdateLookResemblanceAnswerMutation, UpdateLookResemblanceAnswerMutationVariables>(UpdateLookResemblanceAnswerDocument, options);
}
export type UpdateLookResemblanceAnswerMutationHookResult = ReturnType<typeof useUpdateLookResemblanceAnswerMutation>;
export type UpdateLookResemblanceAnswerMutationResult = Apollo.MutationResult<UpdateLookResemblanceAnswerMutation>;
export type UpdateLookResemblanceAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateLookResemblanceAnswerMutation, UpdateLookResemblanceAnswerMutationVariables>;